export default {
  title: `
    Entfesseln Sie Ihr Programmierpotenzial <br /> mit den Live-Kursen von SkillSynergy!
  `,
  meeting: "Reservieren Sie eine kostenlose Beratung",
};
